var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","align-start":"","ma-0":"","pa-2":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_vm._v(" 테스트 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }